<template>
  <div
    :class="{
      modal: true,
      'is-active': active
    }"
  >
    <div class="modal-background" @click="$emit('cancel')"></div>

    <div class="modal-content">
      <div class="box content">
        <h1 class="title">
          {{ title }}
        </h1>
        <p class="text" v-if="text">{{ text }}</p>
        <text-field
          v-model="textValue"
          :placeholder="placeholder"
          @change="$emit('change', textValue)"
          @enter="$emit('confirm', textValue)"
        />
        <modal-footer
          :is-error="isError"
          :is-loading="isLoading"
          @confirm="$emit('confirm', textValue)"
          @cancel="$emit('cancel')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { modalMixin } from '@/components/modals/base_modal'

import ModalFooter from '@/components/modals/ModalFooter'
import TextField from '@/components/widgets/TextField'

export default {
  name: 'edit-text-modal',
  mixins: [modalMixin],

  components: {
    ModalFooter,
    TextField
  },

  props: {
    active: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "text..."
    },
  },

  data () {
    return {
      textValue: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.error {
  margin-top: 1em;
}
</style>
